require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/parse-int.js
// module id = 674
// module chunks = 5